import { performLogout, isLoggingOut } from '~/services/auth/useLogoutService'
import { useAuthStore } from '~/stores/auth/AuthStore'
import { LOGOUT_BEACON_KEY } from '~/services/auth/logoutBeacon'

/**
 * Cross-tab logout beacon (receive side).
 *
 * Runs when another same-origin tab writes the logout beacon. The path is
 * LOCAL-ONLY: it tears down auth state, redirects, and toasts once via
 * `performLogout({ reason: 'cross_tab', skipServer: true })`. It never calls the
 * backend logout endpoint — the emitting tab already revoked every token
 * server-side, so a call here would only produce a guaranteed 401 and could
 * loop. Re-entry is guarded by the logout service's busy flag, and the handler
 * no-ops for unrelated keys and for tabs that hold no auth state.
 */
export const handleLogoutBeacon = (event: StorageEvent): void => {
  if (event.key !== LOGOUT_BEACON_KEY) return
  if (isLoggingOut()) return
  if (!useAuthStore().isLoggedIn) return

  void performLogout({ reason: 'cross_tab', skipServer: true })
}

let listenerRegistered = false

export const registerCrossTabLogoutListener = (): void => {
  if (listenerRegistered) return
  listenerRegistered = true
  window.addEventListener('storage', handleLogoutBeacon)
}
